<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
          <b-button variant="danger" @click="openDeleteModal()" v-if="'portal-users/' + $route.params.id" class="pull-right back-btn">Verwijderen</b-button>
        </b-col>
      </b-row>
      <b-form @submit.prevent="saveItem">
        <b-row>
          <b-col cols="12">
            <b-card no-body>
              <template v-slot:header>
                <span class="pull-left mt-2 mb-2"><strong>Portal User: {{ item.username }} (ID: {{item.id}})</strong></span>
                <a @click="impersonateRedirect" class="btn btn-primary btn-sm text-white hoverable pull-right ml-3">Inloggen als {{item.username}}</a>
                <a @click="sendInvite" class="btn btn-secondary btn-sm hoverable pull-right">Stuur uitnodiging</a>

              </template>
              <b-tabs pills card>
                <b-tab title="Details" active>
                  <b-row class="mt-3 mb-3" v-if="item">
                    <b-col cols="4">
                      <b-col>
                        <b-form-group label="Gebruikersnaam">
                          <b-form-input type="text" required v-model="item.username" disabled></b-form-input>
                        </b-form-group>
                        <b-form-group label="E-mailadres">
                          <b-form-input type="text" required v-model="item.person.email" disabled></b-form-input>
                        </b-form-group>
                        <b-form-group label="Laatst ingelogd">
                          <b-form-input type="text" v-model="item.last_login" disabled></b-form-input>
                        </b-form-group>
                        <b-form-group label="Aangemaakt op">
                          <b-form-input type="text" v-model="item.created_at" disabled></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-col>
                  </b-row>

                  <hr>

                  <b-row class="mt-3 mb-3">
                    <b-col cols="4">
                    <b-col v-if="item.person !== null">
                        <p >
                          Deze portaluser is gekoppeld aan <strong>{{item.person.typeSingle}}</strong>:<br>
                        </p>
                          <b-form-group label="Naam">
                            <b-form-input type="text" v-model="item.person.name" disabled readonly></b-form-input>
                          </b-form-group>
                          <b-form-group label="Salesforce ID">
                            <b-form-input type="text" v-model="item.person.sfId" disabled readonly></b-form-input>
                          </b-form-group>

                          <strong class="btn btn-dark" @click="$router.push({ name: item.person.typePlural+'.view', params: { id: item.person.id } })">Bekijk {{item.person.typeSingle}}</strong>
                        </p>
                      </b-col>
                      <b-col v-if="item.person == null">
                        <p>
                          Deze persoon is <strong>niet gekoppeld</strong> aan een <strong>Salesforce relatie of contactpersoon</strong>. Dit betekent dat er geen data beschikbaar is in de portaal van de gebruiker.
                          </p>
                      </b-col>
                    </b-col>
                  </b-row>
                </b-tab>

                <b-tab title="Documenten">
                  <document-upload v-on:uploadedFiles="updateFiles" />
                  <documents-list v-on:deletedFile="removeFile" :files="documents" />
                </b-tab>
              </b-tabs>

            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <b-modal id="delete-object" ref="delete-object" title="Verwijder object" v-if="deletable">
      <p class="my-4">
        Weet je zeker dat je het object <strong>"{{deletable.username}}"</strong> wilt verwijderen? Deze
        actie is onomkeerbaar.
      </p>
      <template v-slot:modal-footer>
        <b-button @click="hideDeleteModal">Nee</b-button>
        <b-button variant="danger" @click="deleteItem">Ja, verwijder</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {addData, deleteItem, getData, updateData} from '@/api';
import ProjectParticipations from "@/views/projects/parts/Participations";
import ProjectUpdates from "@/views/projects/parts/Updates";
import ProjectKeyData from "@/views/projects/parts/KeyData";
import ProjectFases from "@/views/projects/parts/Fases";
import DocumentUpload from "@/views/portal-users/parts/Upload";
import DocumentsList from "@/views/portal-users/parts/Documents";

import router from "@/router";

export default {
  name: 'project',
  components: {ProjectFases, ProjectKeyData, ProjectUpdates, ProjectParticipations, DocumentUpload, DocumentsList },
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      contacts: [],
      editable: false,
      companyOptions: [],
      countryOptions: [],
      documents: [],
      item: {
        person: {}
      },
      errors: null,
      deletable: []
    }
  },
  methods: {
    async getItem() {
      const item = await getData('portal-users/' + this.$route.params.id).then(response => response.data);
      this.item = item.data;

      const documents = await getData('portal-users/' + this.$route.params.id + '/documents').then(response => response.data);
      this.setDocuments(documents.data);
    },
    async impersonateRedirect() {
      const data = await getData('portal-users/impersonate-request/' + this.$route.params.id).then(response => response.data);
      window.open(data.url, "_blank");
    },
    async saveItem() {
      this.errors = null;
      this.saveButtonDisabled = true;
      const request = await updateData('users/' + this.$route.params.id, {
        'name': this.item.name,
        'email': this.item.email,
        'phonenumber': this.item.phonenumber,
      });
      if (request.status === 200) {
        this.item = request.data.data;
        this.feedback.show = true;
        this.feedback.text = 'Gebruiker succesvol geupdate';
        this.feedback.variant = 'success';
        this.editable = false;
        this.saveButtonDisabled = false;
      } else {
        this.errors = request.data.errors;
        this.feedback.show = true;
        this.feedback.text = 'Er ging iets mis...';
        this.feedback.variant = 'danger';
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
    openDeleteModal() {
      this.deletable = this.item;
      this.$refs['delete-object'].show()
    },
    hideDeleteModal() {
      this.$refs['delete-object'].hide();
    },
    async deleteItem() {
      this.hideDeleteModal();
      await deleteItem('portal-users/' + this.$route.params.id, false);
      await router.push({ name: 'portal-users' });
    },
    countDownChanged(dismissCountDown) {
      this.feedback.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.this.feedback.dismissCountDown = this.dismissSecs
    },
    setDocuments(files = []) {
      const collection = files.sort((a, b) => {
        if (a.label === 'general') return -1;
        else if (b.label === 'general') return 1;
        else {
          return b.label - a.label;
        }
      });

      this.documents = collection;
    },
    async sendInvite() {
      const request = await addData('portal-users/invite', {
        portal_user_id: this.$route.params.id
      }).then(response => response);
      if(request.data === 1) {
        alert('Uitnodiging verzonden');
      } else {
        alert('Er is iets misgegaan... Probeer het opnieuw');
      }
    },
    async updateFiles(data) {
      const documents = await getData('portal-users/' + this.$route.params.id + '/documents').then(response => response.data);
      this.setDocuments(documents.data);
    },
    async removeFile(id) {
      await this.getItem();
      this.item.documents = this.item.documents.filter(file => {
        return file.id != id;
      })

    },

  },
  beforeMount() {
    this.getItem();
  },
}

</script>
